import { ReactNode } from "react"

type Props = {
    children: ReactNode
}

export const GoalsWrapper = ({ children }: Props) => {
    return <div className="goals-wrapper pb-[40px] md:pb-[100px]">{children}</div>
}
